//Install
import React, { Component } from "react";
//Install
import { ReactComponent as Arrow } from "../../../../Media/Icon/002.svg";

//Element
class Menu extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("menu", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB u9g2b1" },
            //Element
            React.createElement("li", { className: "S0u16d" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "/az" },
                    //Element
                    "Əsas"
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d cH8711" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "#" },
                    //Element
                    "Korporativ"
                ),
                //Element
                React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB gBt584" },
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/haqqimizda" },
                            //Element
                            "Haqqımızda",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/tarixce" },
                            //Element
                            "Tarixçə",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/filiallar" },
                            //Element
                            "Filiallar",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/səlahiyyət-sənədləri" },
                            //Element
                            "Səlahiyyət Sənədləri",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    )
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d cH8711" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "#" },
                    //Element
                    "Təqdim Edilən Xidmətlər"
                ),
                //Element
                React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB gBt584" },
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/isiqlandirma" },
                            //Element
                            "İşıqlandırma",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/panel-istehsali" },
                            //Element
                            "Panel İstehsalı",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/elektrik-muqavilesi" },
                            //Element
                            "Elektrik Müqaviləsi",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/yenilene-bilen-enerji" },
                            //Element
                            "Yenilənə Bilən Enerji",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/orta-gerginlik-tesisleri" },
                            //Element
                            "Orta Gərginlik Təsisləri",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    )
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "/az/layiheler" },
                    //Element
                    "Layihələr"
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "/az/davamliliq" },
                    //Element
                    "Davamlılıq"
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "/az/karyera" },
                    //Element
                    "Karyera"
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "/az/elaqe" },
                    //Element
                    "Əlaqə"
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Menu;